export default __webpack_public_path__ + "static/media/WonInactiveLight.a672392b.svg";